import {
    FrontendExperimentsResponse,
    Identifiers
} from "@atlassian/feature-gate-node-client-bootstrapper";

export type FeatureGatesBootstrapValues = FrontendExperimentsResponse & {
    identifiers: Identifiers;
};

export type OverrideValues = {
    experimentOverrides: {
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        [experimentName: string]: any;
    };
    featureGateOverrides: {
        [featureGateName: string]: boolean;
    };
};

export type FeatureGateOverrideValues = {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    [experimentName: string]: any;
};

declare global {
    interface Window {
        featureGateBootstrapValues: FeatureGatesBootstrapValues;
    }
}

export enum StatsigFeatureGateKey {
    BXPSU_2854_CONFLUENCE_PUBLIC_LINK = "bxpsu-2854_confluence_public_link", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2854_confluence_public_link
    JFIND_INTEGRATE_GUPS_IN_JIRA_ONBOARDING = "jfind-integrate-gups-in-jira-onboarding" // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/jfind-integrate-gups-in-jira-onboarding
}

export enum StatsigExperimentKey {
    WAC_SIGNUP_UPGRADE_PATH = "wac_signup_upgrade_path", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/wac_signup_upgrade_path
    JFIND_COMPANY_EXPAND_IMPACT = "jfind-company-expand-impact", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-company-expand-impact
    JFIND_PAID_GET_USERS_BACK_TO_PRODUCT = "jfind-get-users-back-to-product-for-paid", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-get-users-back-to-product-for-paid/setup
    JFIND_REDIRECT_TO_PRODUCT_V2 = "jfind-redirect-logged-in-users-to-product-v2" //https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-redirect-logged-in-users-to-product-v2/setup
}

// Recommend to prefix cohort names with experiment ticket (ex. expcen-1234_variation-1)
export enum StatsigExperimentCohort {
    CONTROL = "control",
    UNEXPECTED_FAILURE = "unexpected_failure",
    NOT_ENROLLED = "not_enrolled",
    WAC_SIGNUP_UPGRADE_PATH_TEST = "test",
    JFIND_COMPANY_EXPAND_IMPACT_VARIANT = "jfind-company-expand-impact",
    JFIND_REDIRECT_TO_PRODUCT_V2_CONTROL = "control",
    JFIND_REDIRECT_TO_PRODUCT_V2_VARIANT = "variant",
    JFIND_PAID_GET_USERS_BACK_TO_PRODUCT_CONTROL = "control",
    JFIND_PAID_GET_USERS_BACK_TO_PRODUCT_VARIANT = "variation"
}
